(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-discount"] && !Shopify.designMode) return;
  try {
    class DiscountCart extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.button = this.querySelector('button');
      this.message = this.querySelector('small');
      this.cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');

      this.button.addEventListener('click', this.submitDiscount.bind(this));
      this.input.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') this.submitDiscount(e);
      });

      document.body.addEventListener('click', (e) => {
        const button = e.target.closest('.remove-discount');
        if (button) {
          this.removeDiscount(button);
        }
      });
    }

    submitDiscount(e) {
      e.preventDefault();
      const code = this.input.value.trim();
      if (!code) {
        this.message.classList.remove('hidden');
        this.input.setAttribute('aria-invalid', 'true');
        this.input.setAttribute('aria-describedby', 'discount-error');
        return;
      }

      this.button.setAttribute('aria-disabled', 'true');
      const sections = [this.dataset.itemsSection, this.dataset.footerSection].filter(Boolean).join(',');
      const url = `${window.Shopify.routes.root}discount/${encodeURIComponent(code)}?sections=${sections}`;

      // Apply it
      fetch(url)
        .then((response) => response.text())
        .then((html) => {
          // Fetch the cart to check applicable flag
          return fetch(`${window.Shopify.routes.root}cart.js`)
            .then((response) => response.json())
            .then((cart) => ({ cart, html }));
        })
        .then(({ cart, html }) => {
          // Find the code in cart.discount_codes
          const entry = cart.discount_codes.find((discount) => discount.code.toLowerCase() === code.toLowerCase());
          const applied = entry?.applicable === true;

          if (applied) {
            // If valid than update DOM using the fetched HTML
            const parsed = JSON.parse(html);
            const cartItems = new DOMParser().parseFromString(parsed[this.dataset.itemsSection], 'text/html');
            const cartFooter = new DOMParser().parseFromString(parsed[this.dataset.footerSection], 'text/html');

            const cartItemsHTML =
              cartItems.querySelector('#main-cart-items .js-contents') || cartItems.querySelector('cart-drawer-items');
            const cartFooterHTML =
              cartFooter.querySelector('#main-cart-footer') || cartItems.querySelector('.drawer__footer');

            if (this.dataset.cartType === 'drawer') {
              document.querySelector('cart-drawer-items').innerHTML = cartItemsHTML.innerHTML;
              document.querySelector('.cart-drawer__footer').innerHTML =
                cartItems.querySelector('.cart-drawer__footer').innerHTML;
            } else {
              document.querySelector('#main-cart-items .js-contents').innerHTML = cartItemsHTML.innerHTML;
              document.querySelector('#main-cart-footer .js-contents').innerHTML = cartFooter.querySelector(
                '#main-cart-footer .js-contents',
              ).innerHTML;
            }

            this.message.classList.add('hidden');
            this.input.removeAttribute('aria-invalid');
            this.input.removeAttribute('aria-describedby');

            if (window.location.pathname.includes('/cart')) {
              setTimeout(() => {
                window.location.reload();
              }, 250);
            }
          } else {
            // Invalid
            this.message.classList.remove('hidden');
            this.input.setAttribute('aria-invalid', 'true');
            this.input.setAttribute('aria-describedby', 'discount-error');
          }

          this.button.setAttribute('aria-disabled', 'false');
        })
        .catch((error) => {
          console.error(error);
          this.message.classList.remove('hidden');
          this.button.setAttribute('aria-disabled', 'false');
        });
    }

    removeDiscount(button) {
      const code = button.dataset.discount;
      const sections = [this.dataset.itemsSection, this.dataset.footerSection].filter(Boolean).join(',');

      // This removes the session-level discount
      document.cookie = 'discount_code=; Max-Age=0; path=/';

      fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' }),
      })
        .then((response) => response.json())
        .then(() => {
          const url = `${window.Shopify.routes.root}?sections=${sections}`;

          return fetch(url)
            .then((res) => res.text())
            .then((html) => {
              const parsed = JSON.parse(html);
              const cartItems = new DOMParser().parseFromString(parsed[this.dataset.itemsSection], 'text/html');
              const cartFooter = new DOMParser().parseFromString(parsed[this.dataset.footerSection], 'text/html');

              const cartItemsHTML =
                cartItems.querySelector('#main-cart-items .js-contents') ||
                cartItems.querySelector('cart-drawer-items');
              const cartFooterHTML =
                cartFooter.querySelector('#main-cart-footer') || cartItems.querySelector('.drawer__footer');

              if (this.dataset.cartType === 'drawer') {
                document.querySelector('cart-drawer-items').innerHTML = cartItemsHTML.innerHTML;
                document.querySelector('.cart-drawer__footer').innerHTML =
                  cartItems.querySelector('.cart-drawer__footer').innerHTML;
              } else {
                document.querySelector('#main-cart-items .js-contents').innerHTML = cartItemsHTML.innerHTML;
                document.querySelector('#main-cart-footer .js-contents').innerHTML = cartFooter.querySelector(
                  '#main-cart-footer .js-contents',
                ).innerHTML;
              }

              // Re-bind removeDiscount event listeners
              document.querySelectorAll('.remove-discount').forEach((btn) => {
                btn.addEventListener('click', this.removeDiscount.bind(this));
              });

              if (window.location.pathname.includes('/cart')) {
                setTimeout(() => {
                  window.location.reload();
                }, 250);
              }
            });
        })
        .catch((error) => {
          console.error('Failed to remove discount:', error);
          this.message.classList.remove('hidden');
        });
    }
  }

  if (!customElements.get('discount-cart')) {
    customElements.define('discount-cart', DiscountCart);
  }
  } catch(e) { console.error(e); }
})();

})();
